import { useRef, useState } from 'react';
import { Telegram } from '@ankr.com/ui';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import { FEEDBACK_LINK } from 'modules/common';
import { useTranslation } from 'modules/i18n';

import { ReactComponent as CloseIcon } from '../../../common/assets/close.svg';
import translation from './testLabel.translation';

export function TestLabel(): JSX.Element {
  const { classes } = useStyles();
  const [showPopover, setShowPopover] = useState(false);
  const rootRef = useRef(null);

  const { t, keys } = useTranslation(translation);

  return (
    <div>
      <Typography
        ref={rootRef}
        variant="body3"
        component="div"
        className={classes.label}
        onClick={() => setShowPopover(true)}
      >
        {t(keys.beta)}
      </Typography>

      <Popover
        classes={{ paper: classes.popover }}
        open={showPopover}
        onClose={() => setShowPopover(false)}
        anchorEl={rootRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorReference="anchorPosition"
        anchorPosition={{ left: 130, top: 60 }}
      >
        <div className={classes.content}>
          <Typography className={classes.text} variant="body3">
            {t(keys.description)}
          </Typography>

          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            component="a"
            href={FEEDBACK_LINK}
            target="_blank"
            rel="noreferrer"
          >
            <Telegram />

            <span>{t(keys.feedback)}</span>
          </Button>

          <CloseIcon
            className={classes.close}
            onClick={() => setShowPopover(false)}
          />
        </div>
      </Popover>
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  label: {
    '&&': {
      color: theme.palette.error.main,
      fontWeight: 500,
      borderRadius: 12,
      padding: theme.spacing(1, 2),
      backgroundColor: theme.palette.common.white,
      cursor: 'pointer',
    },
  },
  popover: {
    '&&': {
      textAlign: 'center',
      maxWidth: 354,
      padding: theme.spacing(4, 9.5, 4, 4),
    },
  },

  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },

  text: {
    '&&': {
      maxWidth: 240,
      textAlign: 'left',
      color: theme.palette.grey[800],
    },
  },

  button: {
    '&&': {
      width: 'max-content',
      minWidth: 184,
      gap: theme.spacing(2),
    },
  },

  close: {
    position: 'absolute',
    top: 0,
    right: theme.spacing(-5),
    color: theme.palette.grey[300],
    cursor: 'pointer',
    transition: 'color 0.2s ease-in-out',

    '&:hover': {
      color: theme.palette.grey[800],
    },
  },
}));
